import styled from "styled-components";

export const StyledInputTag = styled.input`
    border: 0;
    :focus {
        outline: none;
    }
`;
